// actions.js
import {
  FETCH_LINES_REQUEST,
  FETCH_LINES_SUCCESS,
  FETCH_LINES_FAILURE,
  DELETE_LINES_REQUEST,
  DELETE_LINES_FAILURE,
  DELETE_LINES_SUCCESS,
  FETCH_LINE_REQUEST,
  FETCH_LINE_SUCCESS,
  FETCH_LINE_FAILURE,
  UPDATE_LINES_REQUEST,
  UPDATE_LINES_SUCCESS,
  UPDATE_LINES_FAILURE,
  CLEAR_LINE_ERRORS,
  CLEAR_LINE_SUCCESS,
} from './actionTypes';

export const fetchLinesRequest = () => ({
  type: FETCH_LINES_REQUEST,
});

export const fetchLinesSuccess = (lines) => ({
  type: FETCH_LINES_SUCCESS,
  payload: lines,
});

export const fetchLinesFailure = (error) => ({
  type: FETCH_LINES_FAILURE,
  payload: error,
});

export const fetchLineRequest = (id) => ({
  type: FETCH_LINE_REQUEST,
  payload: id
});

export const fetchLineSuccess = (line) => ({
  type: FETCH_LINE_SUCCESS,
  payload: line,
});

export const fetchLineFailure = (error) => ({
  type: FETCH_LINE_FAILURE,
  payload: error,
});

export const updateLineRequest = (line, navigate) => ({
  type: UPDATE_LINES_REQUEST,
  payload: { line, navigate }
});

export const updateLineSuccess = () => ({
  type: UPDATE_LINES_SUCCESS,
});

export const updateLineFailure = (error) => ({
  type: UPDATE_LINES_FAILURE,
  payload: error,
});

export const deleteLineRequest = (id) => ({
  type: DELETE_LINES_REQUEST,
  payload: id
});

export const deleteLineSuccess = (id) => ({
  type: DELETE_LINES_SUCCESS,
  payload: id,
});

export const deleteLineFailure = (error) => ({
  type: DELETE_LINES_FAILURE,
  payload: error,
});

export const clearLineErrors = () => ({
  type: CLEAR_LINE_ERRORS,
});

export const clearLineSuccess = () => ({
  type: CLEAR_LINE_SUCCESS,
});